import { Stack, Text, Title } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/** Page header with title and subtitle for the My Profile page */
export function MyProfileHeader() {
  const { t } = useTranslation()

  return (
    <Stack spacing={4}>
      <Title order={1}>{t('my_profile.title')}</Title>
      <Text color='dimmed' size='sm'>
        {t('my_profile.subtitle')}
      </Text>
    </Stack>
  )
}
